const sessions = {
  sessionBlocked:
    "Vous avez été déconnecté car une connexion a été détectée depuis un autre appareil.",
  sessionWarning:
    "Si vous n'êtes pas à l'origine de cette connexion, veuillez changer votre mot de passe.",
  sessionTabDisabled: "Cet onglet est désactivé",
  sessionTabOpened: "Un autre onglet est ouvert avec votre compte.",
  sessionCloseTab: "Vous pouvez fermer cet onglet.",
  sessionUniqueWarning:
    "iizenglish ne peut être actif que sur un onglet à la fois.",
};

export default sessions;
